import React, { useEffect, useState, useRef, useCallback } from "react";
import "./coinFlip.scss";
import Coin1 from "../../assets/NewBanner/Coin1.png";
import Coin2 from "../../assets/NewBanner/Coin2.png";
import Coin3 from "../../assets/NewBanner/Coin3.png";
import Coin4 from "../../assets/NewBanner/Coin4.png";

const coins = [Coin1, Coin2, Coin3, Coin4];

const CoinFlip = () => {
  // Track the flip state of each coin individually
  const [coinStates, setCoinStates] = useState([
    { isFlipped: false, isFlipping: false },
    { isFlipped: false, isFlipping: false },
    { isFlipped: false, isFlipping: false },
    { isFlipped: false, isFlipping: false }
  ]);
  const [animationStep, setAnimationStep] = useState(0);
  const timeoutRef = useRef(null);

  // Animation sequence steps:
  // 0: First coin flips to back
  // 1: Second coin flips to back
  // 2: Third coin flips to back
  // 3: Fourth coin flips to back
  // 4: First coin flips to front
  // 5: Second coin flips to front
  // 6: Third coin flips to front
  // 7: Fourth coin flips to front

  const runAnimationStep = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Determine which coin to flip and in which direction based on the current step
    const coinIndex = animationStep % 4; // 0, 1, 2, or 3
    const isFlippingToBack = animationStep < 4; // Steps 0-3 flip to back, 4-7 flip to front

    // Update the state of the specific coin
    setCoinStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[coinIndex] = {
        isFlipped: isFlippingToBack, // true when flipped to back, false when flipped to front
        isFlipping: true
      };
      return newStates;
    });

    // After the flip animation completes, update the flipping state
    timeoutRef.current = setTimeout(() => {
      setCoinStates((prevStates) => {
        const newStates = [...prevStates];
        newStates[coinIndex] = {
          isFlipped: isFlippingToBack,
          isFlipping: false
        };
        return newStates;
      });

      // Move to the next step after a delay
      timeoutRef.current = setTimeout(() => {
        const nextStep = (animationStep + 1) % 8;
        setAnimationStep(nextStep);
      }, 1000); // Delay before starting the next flip
    }, 400); // Duration of the flip animation
  }, [animationStep]);

  // Start the animation sequence
  useEffect(() => {
    runAnimationStep();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [runAnimationStep]);

  return (
    <div className="coinFlipContainer">
      {coins.map((coin, index) => (
        <div key={index} className="coinWrapper">
          <div
            className={`coin ${coinStates[index].isFlipping ? "active" : ""}`}
            style={{
              transform: coinStates[index].isFlipped
                ? "rotateY(180deg)"
                : "rotateY(0deg)",
              transition: coinStates[index].isFlipping
                ? "transform 0.4s ease-in-out"
                : "none"
            }}
          >
            <div className="coin-face coin-front">
              <img src={coin} alt={`coin${index + 1}`} className="coinImage" />
            </div>
            <div className="coin-face coin-back">
              <img
                src={coin}
                alt={`coin${index + 1} back`}
                className="coinImage"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CoinFlip;
